import { Card, Grid } from "@mui/material";
import FormField from "components/FormField/FormField";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect/MDSelect";
import MDTypography from "components/MDTypography";
import useGetOrganizationSettings from "hooks/organization/useGetOrganizationSettings";
import useUpdateOrganizationSettings from "hooks/organization/useUpdateOrganizationSettings";
import { useEffect, useState } from "react";

const ESTIMATING_METHOD_OPTIONS = [
  { value: "production", label: "Production-based" },
  { value: "worksheet", label: "Worksheet" },
];

const parseSettingValue = (value?: string): unknown => {
  if (value === undefined) {
    return undefined;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export default function EstimatingDefaults() {
  const { data: settings, loading } = useGetOrganizationSettings();
  const { updateOrganizationSettings } = useUpdateOrganizationSettings();
  const [method, setMethod] = useState("production");
  const [markup, setMarkup] = useState("0");

  useEffect(() => {
    if (settings) {
      setMethod((parseSettingValue(settings.default_estimating_method) as string) ?? "production");
      setMarkup(String(parseSettingValue(settings.default_worksheet_markup) ?? 0));
    }
  }, [settings]);

  return (
    <Card sx={{ p: "25px", mb: "20px" }}>
      <MDTypography variant="h6" sx={{ mb: 1 }}>
        Estimating defaults
      </MDTypography>
      <MDTypography variant="body2" sx={{ mb: 2 }}>
        Applies to new proposals and new worksheet line items. Existing proposals retain their
        estimating method.
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <MDSelect
            label="Default estimating method"
            name="defaultEstimatingMethod"
            fullWidth
            value={method}
            onChange={(event) => setMethod(event.target.value as string)}
            options={ESTIMATING_METHOD_OPTIONS}
            readOnly={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormField
            disabled={loading}
            type="number"
            label="Default worksheet markup (%)"
            value={markup}
            inputProps={{ min: 0, step: "0.0001" }}
            onChange={(event) => setMarkup(event.target.value)}
          />
        </Grid>
      </Grid>
      <MDBox display="flex" justifyContent="flex-end" mt={2}>
        <MDButton
          variant="gradient"
          color="success"
          disabled={loading}
          onClick={() =>
            updateOrganizationSettings({
              default_estimating_method: method,
              default_worksheet_markup: Number(markup) || 0,
            })
          }
        >
          Save estimating defaults
        </MDButton>
      </MDBox>
    </Card>
  );
}
